import { render } from "./SelectionOption.vue?vue&type=template&id=f61b8ab0&scoped=true"
import script from "./SelectionOption.vue?vue&type=script&lang=js"
export * from "./SelectionOption.vue?vue&type=script&lang=js"

import "./SelectionOption.vue?vue&type=style&index=0&id=f61b8ab0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61b8ab0"]])

export default __exports__